import React from 'react';
import { CircularProgress, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ShareRounded } from '@mui/icons-material';

import { useArchetypeShare } from '@shared/hooks/useArchetypeShare';

type Props = {
  archetype: string;
  archetypeDescription?: string | null;
  label: string;
  onAfterShare: () => void;
};

export const ShareListItem: React.FC<Props> = ({ archetype, archetypeDescription, label, onAfterShare }) => {
  const { share, isGenerating, hiddenCard } = useArchetypeShare({ archetype, archetypeDescription });

  const handleClick = async () => {
    await share();
    onAfterShare();
  };

  return (
    <>
      {hiddenCard}
      <ListItemButton onClick={handleClick} disabled={isGenerating} sx={{ my: 1 }}>
        <ListItemIcon>
          {isGenerating ? <CircularProgress size={20} /> : <ShareRounded />}
        </ListItemIcon>
        <ListItemText primary={label} slotProps={{ primary: { variant: 'body2', noWrap: true } }} />
      </ListItemButton>
    </>
  );
};
